<template>
  <div class="peoplechoice">
    <Header :title="$t('m.CheckinRecord')"></Header>
    <div class="main">
      <span
        v-if="array.length == '0'"
        style="color:red;height: 40px;display:block;line-height: 50px;text-align: center;font-size: 16px;font-weight: bolder;"
      >{{$t('m.NoCheckinPerson')}}</span>
      <div v-else :index="item.key" :key="index" class="mainitem" v-for="(item,index) in array">
        <div class="content">
          <div :key="mindex" class="contentitem" v-for="(mitem,mindex) in item.array">
            <span>
              <span @click.stop.prevent="getusermessage(mitem)" class="headerpicwarp">
                <img :src="mitem.image" alt class="headerpic" />
              </span>
              <span
                style="display:inline-block;font-size:0.12rem; word-break:keep-all;white-space:nowrap;text-overflow:ellipsis"
              >{{mitem.departmentName}}</span>
              <span
                style="display:inline-block;margin-left:0.2rem;font-size:0.12rem; word-break:keep-all;white-space:nowrap;text-overflow:ellipsis"
              >{{mitem.username}}</span>
              <span
                style="display:inline-block;margin-left:0.2rem;font-size:0.12rem; word-break:keep-all;white-space:nowrap;text-overflow:ellipsis"
              >{{mitem.sign_time | formatDate}}</span>
            </span>
          </div>
        </div>
      </div>
      <!-- </CheckboxGroup>    -->
    </div>
    <div class="asd">
      <span>{{$t('m.CheckinNumber')}}{{arrayLength}}</span>
      <span>{{$t('m.MeetingColon')}}{{meetingTime}}</span>
    </div>
    <div class="right bgc3">
      <span :key="index" @click="tothis(item)" v-for="(item,index) in myset">{{item}}</span>
    </div>
    <div @click="sure" class="bottom bgc">{{$t('m.OKBtn')}}</div>
    <div class="pop" v-if="popshow">
      <div class="templatepop">
        <div @click="closeallpop" class="popclosex">
          <Icon type="ios-close"></Icon>
        </div>
        <div style="height:1rem;text-align:center">
          <img :src="usermessage.image" alt style="height:1rem;width:1rem;border-radius:50%" />
        </div>
        <div class="contentitem">
          <span class="leftspan">{{$t('m.NameColon')}}</span>
          {{usermessage.username}}
        </div>
        <div class="contentitem">
          <span class="leftspan">{{$t('m.UnitColon')}}</span>
          {{usermessage.departmentName}}
        </div>
        <div class="contentitem">
          <span class="leftspan">{{$t('m.MobileColon')}}</span>
          {{usermessage.mobile}}
        </div>
        <div class="contentitem">
          <span class="leftspan">{{$t('m.EMailColon')}}</span>
          {{usermessage.email}}
        </div>
        <div class="contentitem">
          <!-- <span class="leftspan">地址：</span> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../header/header";
import {
  getFirstDepartment,
  getSecondDepartment,
  getUserByDepartmentId,
  selectSignin
} from "../../assets/js/url";
import { formatDate } from "../../assets/js/date";

export default {
  filters: {
    formatDate(sign_time) {
      var date = new Date(sign_time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    }
  },

  name: "peoplechoice",
  data() {
    return {
      social: [],
      array: [],
      data: Object,
      myset: [],
      searchcontent: "",
      meetinguuid: "",
      usermessage: Object,
      popshow: false,
      departmentData: {}
    };
  },
  components: {
    Header
  },
  activated() {
    this.social = [];
    // this.getDepartment();
    this.id = this.$route.query.id;
    this.getCheckinList();
  },
  methods: {
    getDepartment() {
      this.$http
        .post(getFirstDepartment, {
          useruuid: window.sessionStorage.getItem("UUID")
        })
        .then(res => {
          if (res.data.status === 2000) {
            let firstDepartmentData = res.data.data;
            for (let i = 0; i < firstDepartmentData.length; i++) {
              this.$http
                .post(getSecondDepartment, {
                  firstDepartmentId: firstDepartmentData[i].id,
                  useruuid: window.sessionStorage.getItem("UUID")
                })
                .then(res => {
                  if (res.data.status === 2000) {
                    let data = res.data.data;
                    this.departmentData[data[i].id] = data[i].name;
                  }
                });
            }
          }
        });
    },
    search() {
      if (this.searchcontent) {
        $(".title").css("display", "none");
        $(".contentitem").css("display", "none");
        $(
          ".contentitem:contains(" + this.searchcontent.toLowerCase() + ")"
        ).css("display", "block");
      } else {
        $(".title").css("display", "block");
        $(".contentitem").css("display", "block");
      }
    },
    tothis(item) {
      const top = $('[index="' + item + '"]').offset().top;
      $(window).scrollTop(top - $(window).height() * 0.2);
    },
    getusermessage(item) {
      this.usermessage = item;
      this.popshow = true;
    },
    closeallpop() {
      this.popshow = false;
    },
    getCheckinList() {
      this.$loadingshow();
      this.$http
        .post(selectSignin, {
          cfIdInWeMeet: this.id
        })
        .then(
          res => {
            this.$loadingclose();
            if (res.data.status == 2000) {
              const data = res.data.data;
              let arrayLength = res.data;
              this.arrayLength = arrayLength.signinTotal;
              this.meetingTime = arrayLength.create_time;
              const mymap = new Map();
              const hasname = [];
              const haspingying = [];
              const hasdepartment = [];
              const set = data.map(function(item, index) {
                if ("name" in item && "useruuid" in item) {
                  mymap.set(item.useruuid, item.name);
                }
                if ("name" in item) {
                  hasname.push(item.name);
                }
                if ("full_py" in item) {
                  haspingying.push(item.full_py[0]);
                }
                if ("name" in item && "full_py" in item) {
                  if (/^[0-9]*$/.test(item.name) || item.full_py === "") {
                    item.key = "#";
                    return "#";
                  } else {
                    item.key = item.full_py[0].toUpperCase();
                    return item.full_py[0].toUpperCase();
                  }
                }
              });
              this.data = mymap;
              const myset = new Set(set);
              const key = Array.from(myset).sort();
              this.myset = key;
              this.array = [];
              for (let i = 0; i < key.length; i++) {
                this.array.push({
                  key: key[i],
                  array: data
                    .filter(function(item, index) {
                      return item.key == key[i];
                    })
                    .sort()
                });
              }
            } else {
              this.$toast(this.$t('m.CheckinListGetFail'));
            }
          },
          err => {
            this.$loadingclose();
            this.$toast(this.$t('m.NetworkException'));
          }
        );
    },
    sure() {
      this.$router.go(-1);
    }
  },
  computed: {
    choice() {
      return " ";
    }
  }
};
</script>
<style scoped>
.peoplechoice {
  width: 100%;
}

.serch {
  height: 0.52rem;
  line-height: 0.52rem;
  padding: 0 0.15rem;
  font-size: 0.15rem;
  width: 100%;
  position: fixed;
  top: 0.44rem;
  left: 0;
  background-color: #fff;
  z-index: 100;
  border-bottom: 1px solid #ddd;
}

.choice {
  padding: 0.15rem 0.45rem 0.05rem 0.15rem;
  line-height: 0.3rem;
  padding-top: 0.5rem;
}

.serchbox {
  width: 1.8rem;
  height: 0.32rem;
  line-height: 0.32rem;
  display: inline-block;
  margin-top: 0.1rem;
  border-radius: 5px;
  border: 1px solid #ddd;
  float: left;
  margin-right: 0.1rem;
  box-sizing: border-box;
  padding: 0 0.1rem;
}

.searchinput {
  width: 1.2rem;
  height: 0.32rem;
  border: none;
  background-color: transparent;
  outline: none;
  line-height: 0.32rem;
}

i {
  font-size: 0.2rem;
}

.title {
  padding: 0 0.15rem;
  height: 0.28rem;
  background-color: #f8f8f8;
  line-height: 0.28rem;
  font-size: 0.16rem;
  font-weight: bold;
}

.contentitem {
  height: 0.41rem;
  font-size: 0.16rem;
  line-height: 0.41rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.main {
  padding: 0 0 0.5rem;
}

.content {
  padding: 0rem 0.15rem;
  line-height: 0.2rem;
}

.bottom {
  width: 100%;
  height: 0.49rem;
  line-height: 0.49rem;
  color: #fff;
  font-size: 0.18rem;
  text-align: center;
  position: fixed;
  bottom: 0px;
  left: 0px;
}

.right {
  position: fixed;
  top: 1rem;
  right: 0px;
  width: 0.38rem;
  background-color: #fff;
  padding: 0;
  height: 75vh;
  overflow-y: scroll;
}

.right span {
  width: 100%;
  line-height: 0.16rem;
  display: inline-block;
  text-align: center;
}

.headerpicwarp {
  display: inline-block;
  width: 0.35rem;
  height: 0.41rem;
  line-height: 0.41rem;
  text-align: center;
  float: left;
}

.headerpic {
  width: 0.35rem;
  height: 0.35rem;
  vertical-align: middle;
  float: left;
}

.pop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}

.templatepop {
  width: 3rem;
  height: 3.6rem;
  background-color: #fff;
  border-radius: 5px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -1.8rem;
  margin-left: -1.5rem;
  box-sizing: border-box;
  padding: 0.4rem 0;
  font-size: 0.15rem;
}

.popclosex {
  position: absolute;
  top: 0.1rem;
  right: 0.1rem;
}

.leftspan {
  display: inline-block;
  width: 0.5rem;
  text-align: center;
  margin-left: 0.2rem;
}
.asd {
  position: absolute;
  bottom: 0.52rem;
  padding-left: 0.7rem;
}
</style>




// WEBPACK FOOTER //
// src/components/content/checkinrecord.vue